<script lang="ts">
  import type { ContactStoryblok } from '$types/bloks';
  import Contact from './contact.svelte';

  export let block: ContactStoryblok;
</script>

{#if block}
  <section class="overflow-hidden px-2 py-12 lg:px-8 lg:py-16">
    <div class="container mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-2.5 lg:gap-4">
        {#each block.contacts as contact}
          <Contact block={contact} />
        {/each}
      </div>
    </div>
  </section>
{/if}
